import * as React from 'react';
import styled from 'styled-components';

import { Icon, IconStyled } from '@longline/aqua-ui/controls/Icon';
import { NumberFormatter } from '@longline/aqua-ui/formatters/NumberFormatter';
import { SVG } from '@longline/aqua-ui/svg';

interface IProps {
  /** @ignore */
  className?: string;
  structureDepth: number;
  maxDepth: number;
}

const BathymetryWarningBase = (props: IProps) => 
  <div className={props.className}>
    <Icon size="huge" url={SVG.Icons.Warning}/> 
    <div>
      <b>Warning:</b> structure depth of <b><NumberFormatter value={props.structureDepth} decimals={1}/>m</b> exceeds
      bathymetry (<b><NumberFormatter value={props.maxDepth} decimals={1}/>m</b>). 
      Proceeding will set structure depth to <b><NumberFormatter value={Math.floor(props.maxDepth)} decimals={1}/>m</b>.        
    </div>
  </div>

const BathymetryWarning = styled(BathymetryWarningBase)`
  background-color: #600;
  border-radius: ${p => p.theme.radius.normal}px;
  padding: 8px;
  display: flex; 
  justify-content: start;
  align-items: top;
  gap: 8px;
  margin-bottom: 4px;
  ${IconStyled} {
    fill: ${p => p.theme.colors.accent};
  }
`

export { BathymetryWarning }
